function scriptLoader(path, callback) {
  var scriptAll = document.createElement("script");
  scriptAll.type = "text/javascript";
  scriptAll.async = true;
  scriptAll.src = path;
  scriptAll.onload = function () {
    if (typeof callback == "function") {
      callback();
    }
  };
  try {
    var scriptOne = document.getElementsByTagName("script")[0];
    scriptOne.parentNode.insertBefore(script, scriptOne);
  } catch (e) {
    document.getElementsByTagName("head")[0].appendChild(scriptAll);
  }
}

// scriptLoader("../source_assets/js/custom.js");
// scriptLoader("../source_assets/js/custom_2.js");

$(document).ready(function () {
  $(".social-icon a").text("");
  $(".social-icon a").append("<span class='screen-reader-text'>Find us on Facebook</span>");
  $(".ot-sdk-show-settings").attr("id", "ot-sdk-btn");
  $(".social-icon a").attr("arial-label", "Facebook");
});

///////// Scroll to specific values
// scrollTo is the same
// window.scroll({
//   top: 2500,
//   left: 0,
//   behavior: "smooth"
// });

// Scroll certain amounts from current position
// window.scrollBy({
//   top: 100, // could be negative value
//   left: 0,
//   behavior: "smooth"
// });

// Scroll to a certain element
// document.querySelector(".hello").scrollIntoView({
//   behavior: "smooth"
// });

initSmoothScrolling();

function initSmoothScrolling() {
  var duration = 400;

  var pageUrl = location.hash ? stripHash(location.href) : location.href;

  delegatedLinkHijacking();
  //directLinkHijacking();

  function delegatedLinkHijacking() {
    document.body.addEventListener("click", onClick, false);

    function onClick(e) {
      if (!isInPageLink(e.target)) return;

      e.stopPropagation();
      e.preventDefault();

      jump(e.target.hash, {
        duration: duration,
        callback: function () {
          setFocus(e.target.hash);
        }
      });
    }
  }

  // function directLinkHijacking() {
  //   [].slice
  //     .call(document.querySelectorAll("a"))
  //     .filter(isInPageLink)
  //     .forEach(function(a) {
  //       a.addEventListener("click", onClick, false);
  //     });

  //   function onClick(e) {
  //     e.stopPropagation();
  //     e.preventDefault();

  //     jump(e.target.hash, {
  //       duration: duration
  //     });
  //   }
  // }

  function isInPageLink(n) {
    return n.tagName.toLowerCase() === "a" && n.hash.length > 0 && stripHash(n.href) === pageUrl;
  }

  function stripHash(url) {
    return url.slice(0, url.lastIndexOf("#"));
  }

  function isCssSmoothSCrollSupported() {
    return "scrollBehavior" in document.documentElement.style;
  }

  // Adapted from:
  // https://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
  function setFocus(hash) {
    var element = document.getElementById(hash.substring(1));

    if (element) {
      if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
        element.tabIndex = -1;
      }

      element.focus();
    }
  }
}

function jump(target, options) {
  var start = window.pageYOffset,
    opt = {
      duration: options.duration,
      offset: options.offset || 0,
      callback: options.callback,
      easing: options.easing || easeInOutQuad
    },
    distance = typeof target === "string" ? opt.offset + document.querySelector(target).getBoundingClientRect().top : target,
    duration = typeof opt.duration === "function" ? opt.duration(distance) : opt.duration,
    timeStart,
    timeElapsed;

  requestAnimationFrame(function (time) {
    timeStart = time;
    loop(time);
  });

  function loop(time) {
    timeElapsed = time - timeStart;

    window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));

    // if (timeElapsed < duration) requestAnimationFrame(loop);
    // else
    end();
  }

  function end() {
    window.scrollTo(0, start + distance);

    if (typeof opt.callback === "function") opt.callback();
  }

  // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }
}

//Location Maps
$(document).ready(function () {
  //updateMapHeight();
  updateTextContainerMargin();
  $(window).resize(updateTextContainerMargin);

  var zoomConfig = {
    zoomType: "lens",
    lensShape: "round",
    lensSize: 300,
    borderColour: "#FFF",
    containLensZoom: true,
    lensFadeIn: 300,
    lensFadeOut: 300
  };
  $(".mapImage").elevateZoom(zoomConfig);

  var $target = $("#content");
  $("html, body")
    .stop()
    .animate(
      {
        scrollTop: $target.offset()
      },
      900,
      "swing"
    );

  function updateTextContainerMargin() {
    var left;
    if ($(".site-branding").length > 0) {
      left = $(".site-branding").position().left;
    } else {
      left = "20px";
    }

    $(".textContainer").css("margin-left", left + "px");
  }

  //bootstrap equal height damages the responsiveness and table display not working.
  //seems to be the only way for responsiveness and equal height
  function updateMapHeight() {
    var height = $(".textContainer").height();
    if (height > $(".mapImage").height()) {
      $(".mapImage").css("height", height + "px");
    }
  }
});

//For Scroll to top button
$(window).scroll(function () {
  if ($(window).scrollTop() > 100) {
    $(".toTop").fadeIn("slow");
  } else {
    $(".toTop").fadeOut("fast");
  }
});

//Location Page Map
$(document).ready(function () {
  //IE having trouble with height of SVG
  //updateMapHeight();
  //$(window).resize(updateMapHeight);

  $("path, polyline").on("click", function () {
    ClickableMap.mapAreaClicked(this, "{area}");
  });
  $("path, polyline")
    .not("[stroke-linecap]")
    .hover(
      function () {
        ClickableMap.mapAreaMouseOver(this);
      },
      function () {
        ClickableMap.mapAreaMouseLeave();
      }
    );

  function updateMapHeight() {
    $("svg").css("height", $(".wp-block-column").height() + 45 + "px");
  }
});
//Mobile Menu TabIndex
const mobileMenuIcon = document.getElementById('menu-btn');
let allMenuLinks = document.querySelectorAll('.menu-main-menu-container ul.menu li a');
const mediaQuery = window.matchMedia('(max-width: 771px)');

if (mediaQuery.matches) {
  allMenuLinks.forEach(link => { 
      link.setAttribute('tabindex', -1);
      link.setAttribute('aria-hidden', true);
  });

  mobileMenuIcon.addEventListener('click', () => {
 
    allMenuLinks.forEach(link => {
        if (mobileMenuIcon.checked) {
          link.setAttribute('tabindex', 0);
          link.setAttribute('aria-hidden', false);
        } else {
          link.setAttribute('tabindex', -1);
          link.setAttribute('aria-hidden', true);
        }
      });
  
  })
}



